import { isDate } from 'date-fns'
import { ref, req, withParams } from 'vuelidate/lib/validators/common'
export default {
  NoSpacesRequiredIf: prop => {
    return withParams({ type: 'NoSpacesRequiredIf', prop }, function(value, parentVm) {
      if (typeof value === 'string') {
        return ref(prop, this, parentVm) ? value.trim().length !== 0 && req(value) : true
      } else {
        return ref(prop, this, parentVm) ? req(value) : true
      }
    })
  },
  minmaxnumber: data => {
    return withParams({ type: 'minmaxnumber', data }, value => {
      let min = data[0]
      let max = data[1]

      if (value >= min && value <= max) {
        // decimalen controleren
        let notdec = value.indexOf('.') === -1
        return notdec
      } else {
        return false
      }
    })
  },
  // checkIf kijkt of deze validator uberhaubt af moet gaan
  isnumericIf: checkIf => {
    return withParams({ type: 'isnumericIf', checkIf }, value => {
      if (checkIf) {
        return !isNaN(parseFloat(value)) && isFinite(value) // check op numierieke waarde
      } else {
        return true // hoeft niet numeriek te zijn dus altijd doorlaten
      }
    })
  },
  isdate: () => {
    return withParams({ type: 'isdate' }, value => {
      return isDate(value) // check op datum
    })
  },
  isdateorEmpty: () => {
    return withParams({ type: 'isdate' }, value => {
      return isDate(value) || value === null // check op datum, als de value undefined is betekent dit NOT VALID zie util.parseDate
    })
  },
  isDateBiggerThen: secondDate =>
    withParams({ type: 'isDateBiggerThen', eq: secondDate }, function(firstDate, parentVm) {
      return firstDate >= ref(secondDate, this, parentVm)
    }),
  isDateBiggerThenOrEmpty: secondDate =>
    withParams({ type: 'isDateBiggerThen', eq: secondDate }, function(firstDate, parentVm) {
      return firstDate >= ref(secondDate, this, parentVm) || firstDate === null
    })
}
